// How much an order has paid and what is still due.
// Mirrors BackEndWeb2/src/billPayment.js — keep the two in step.
//
// paidAmount (nullable) is only written once an order's price changes after money came in.
// NULL keeps the original meaning: a settled order paid exactly its totalAmount.

export const money = (value) => Math.round(Number(value) || 0);
const lower = (value) => String(value || '').toLowerCase();

const hasRecordedPaidAmount = (bill) =>
    Boolean(bill) && bill.paidAmount !== null && bill.paidAmount !== undefined && bill.paidAmount !== '';

export const isCancelled = (bill) =>
    lower(bill && bill.status).includes('hủy') || lower(bill && bill.paymentStatus) === 'cancelled';

/** Paid something, but the order has since grown — the difference is still owed. */
export const isPartial = (bill) =>
    Boolean(bill) && !isCancelled(bill) && lower(bill.paymentStatus) === 'partial';

/** Settled in full. Same rules the admin list has always used, with 'partial' excluded. */
export function isFullyPaid(bill) {
    if (!bill || isCancelled(bill) || isPartial(bill)) return false;
    const s = lower(bill.status);
    const ps = lower(bill.paymentStatus);
    if (ps === 'paid' || s.includes('đã thanh toán')) return true;
    if (s.includes('chờ') || ps === 'pending') return false;
    return s.includes('làm') || s.includes('giao');
}

export function paidAmountOf(bill) {
    if (!bill) return 0;
    if (isPartial(bill)) return money(bill.paidAmount);
    if (!isFullyPaid(bill)) return 0;
    return hasRecordedPaidAmount(bill) ? money(bill.paidAmount) : money(bill.totalAmount);
}

export function amountDueOf(bill) {
    if (!bill || isCancelled(bill)) return 0;
    return Math.max(0, money(bill.totalAmount) - paidAmountOf(bill));
}

export function refundDueOf(bill) {
    if (!bill || isCancelled(bill)) return 0;
    return Math.max(0, paidAmountOf(bill) - money(bill.totalAmount));
}

/** Flavours can still change until the order leaves the kitchen. */
export const canChangeFlavor = (bill) =>
    Boolean(bill) && !isCancelled(bill) && !lower(bill.status).includes('giao');
